// DS6.17 - Radio button semantics
import React from 'react';
import c from 'classnames';
import HeadlessRadioButton, {
  RadioButtonProps as HeadlessRadioButtonProps,
} from '@wix/da-a11y/pkg/components/formControls/RadioButton';
import commonStyles from '../../common.scss';
import s from './LozengeRadioButton.scss';

type Props = HeadlessRadioButtonProps & {
  selectedClassName?: string;
};

/**
 * A radio button in the shape of a lozenge.
 *
 * This component has no theme, so be careful where you use it. Be sure to check contrast values
 * for accessibility compliance.
 */
const LozengeRadioButton: React.FC<Props> = ({
  checked,
  children,
  className: consumerProvidedClassName,
  selectedClassName,
  ...rest
}) => {
  return (
    <HeadlessRadioButton
      checked={checked}
      className={s['headless-wrapper']}
      {...rest}
    >
      <div
        className={c(
          s['visible-root'],
          commonStyles['root'],
          checked && s['selected'],
          checked && selectedClassName,
          consumerProvidedClassName
        )}
      >
        {children}
      </div>
    </HeadlessRadioButton>
  );
};

LozengeRadioButton.displayName = 'LozengeRadioButton';

export default LozengeRadioButton;
